// extracted by mini-css-extract-plugin
module.exports = {"videoThumbnail":"TeaserLargeMedia_videoThumbnail__HQA2M","map":"TeaserLargeMedia_map__LWUfA"};